export const enum VehicleRole {
  PRIMARYDRIVER = 'primarydriver',
  ADDITIONALDRIVER = 'additionaldriver',
  DRIVER = 'driver'
}
